import { getComprobanteFiscalClienteDowload, postCargarFactura } from "../services/documentosService";
import { getSolicitudFacturasValidasAll, putAceptarFactura, putDeclinarSolitudFacturaFinanzas, putValidateSolicitudFactura } from "../services/invoiceService";

const dataInicial = {
    listFacturasAceptadas: [],
    pagina: 0,
    registros: 10,
    busqueda: "0",
    total: 0,
    exito: 0,
}

const GET_FACTURACION_ACEPTADAS_ALL = "GET_FACTURACION_ACEPTADAS_ALL"
const GET_FACTURACION_ACEPTADAS_PAGINA = "GET_FACTURACION_ACEPTADAS_PAGINA"
const GET_FACTURACION_ACEPTADAS_REGISTROS = "GET_FACTURACION_ACEPTADAS_REGISTROS"
const GET_FACTURACION_ACEPTADAS_BUSQUEDA = "GET_FACTURACION_ACEPTADAS_BUSQUEDA"
const CLEAR_FACTURACION_ACEPTADAS = "CLEAR_FACTURACION_ACEPTADAS"
const GET_FACTURACION_ESTADO_CUENTA_DOWLOAD = "GET_FACTURACION_ESTADO_CUENTA_DOWLOAD"
const PUT_FACTURACION_ACEPTADAS_APROVAR = "PUT_FACTURACION_ACEPTADAS_APROVAR"
const PUT_FACTURACION_ACEPTADAS_DECLINAR = "PUT_FACTURACION_ACEPTADAS_DECLINAR"
const PUT_FACTURAS_ACEPTADAS_CARGAR_ARCHIVO = "PUT_FACTURAS_ACEPTADAS_CARGAR_ARCHIVO"
//* metodos para finanzas
export default function facturacionAceptadasReducer(state = dataInicial, action) {
    switch (action.type) {
        case PUT_FACTURAS_ACEPTADAS_CARGAR_ARCHIVO:
            return { ...state, exito: action.payload.exito }
        case PUT_FACTURACION_ACEPTADAS_DECLINAR:
            return { ...state, exito: action.payload.exito }
        case PUT_FACTURACION_ACEPTADAS_APROVAR:
            return { ...state, exito: action.payload.exito }
        case GET_FACTURACION_ESTADO_CUENTA_DOWLOAD:
            return { ...state, exito: action.payload.exito }
        case GET_FACTURACION_ACEPTADAS_ALL:
            return { ...state, listFacturasAceptadas: action.payload.listFacturasAceptadas, total: action.payload.total }
        case GET_FACTURACION_ACEPTADAS_PAGINA:
            return { ...state, listFacturasAceptadas: action.payload.listFacturasAceptadas, pagina: action.payload.pagina, total: action.payload.total }
        case GET_FACTURACION_ACEPTADAS_REGISTROS:
            return { ...state, listFacturasAceptadas: action.payload.listFacturasAceptadas, registros: action.payload.registros, total: action.payload.total }
        case GET_FACTURACION_ACEPTADAS_BUSQUEDA:
            return { ...state, listFacturasAceptadas: action.payload.listFacturasAceptadas, busqueda: action.payload.busqueda, total: action.payload.total, pagina: action.payload.pagina, registros: action.payload.registros }
        case CLEAR_FACTURACION_ACEPTADAS:
            return { ...state, listFacturasAceptadas: action.payload.array, pagina: action.payload.pagina, registros: action.payload.registros, busqueda: action.payload.busqueda }
        default:
            return state;
    }
}

export const obtenerFacturasAceptadasAction = () => async (dispatch, getSate) => {
    const { busqueda, pagina, registros } = getSate().facturasAceptadas
    return await getSolicitudFacturasValidasAll({ Pagina: pagina + 1, Referencia: busqueda, Registros: registros }).then(Response => {
        dispatch({
            type: GET_FACTURACION_ACEPTADAS_ALL,
            payload: {
                listFacturasAceptadas: Response.Facturas,
                total: Response.Total
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerFacturasAceptadasPaginaAction = ({ Pagina }) => async (dispatch, getSate) => {
    const { busqueda, registros } = getSate().facturasAceptadas
    return await getSolicitudFacturasValidasAll({ Pagina: Pagina + 1, Referencia: busqueda, Registros: registros }).then(Response => {
        dispatch({
            type: GET_FACTURACION_ACEPTADAS_PAGINA,
            payload: {
                listFacturasAceptadas: Response.Facturas,
                total: Response.Total
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerFacturasAceptadasRegistrosAction = ({ Registros }) => async (dispatch, getSate) => {
    const { busqueda, pagina } = getSate().facturasAceptadas
    return await getSolicitudFacturasValidasAll({ Referencia: busqueda, Pagina: pagina + 1, Registros }).then(Response => {
        dispatch({
            type: GET_FACTURACION_ACEPTADAS_REGISTROS,
            payload: {
                listFacturasAceptadas: Response.Facturas,
                total: Response.Total,
                registros: Registros,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerFacturasAceptadasBusquedaAction = ({ Referencia }) => async (dispatch, getSate) => {
    return await getSolicitudFacturasValidasAll({ Referencia: Referencia, Pagina: dataInicial.pagina + 1, Registros: dataInicial.registros }).then(Response => {
        dispatch({
            type: GET_FACTURACION_ACEPTADAS_BUSQUEDA,
            payload: {
                listFacturasAceptadas: Response.Facturas,
                total: Response.Total,
                busqueda: Referencia,
                registros: dataInicial.registros,
                pagina: dataInicial.pagina,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerComprobanteFiscalAction = ({ IdFactura }) => async (dispatch, getSate) => {
    return await getComprobanteFiscalClienteDowload({ IdFactura }).then(Response => {
        dispatch({
            type: GET_FACTURACION_ESTADO_CUENTA_DOWLOAD,
            payload: {
                exito: 1
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const aprobarFacturaction = ({ IdFactura }) => async (dispatch) => {
    return await putAceptarFactura({ IdFactura }).then(Response => {
        dispatch({
            type: PUT_FACTURACION_ACEPTADAS_APROVAR,
            payload: {
                exito: 1
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const declinarFacturasAction = ({ IdFactura }) => async (dispatch) => {
    return await putDeclinarSolitudFacturaFinanzas({ IdFactura }).then(Response => {
        dispatch({
            type: PUT_FACTURACION_ACEPTADAS_DECLINAR,
            payload: {
                exito: 1
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const cargarFacturaAction = ({ Extension, IdFactura, Imagen, Nombre }) => async (dispatch) => {
    return await postCargarFactura({ Extension, IdFactura, Imagen, Nombre }).then(Response => {
        dispatch({
            type: PUT_FACTURAS_ACEPTADAS_CARGAR_ARCHIVO,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}